<template>
  <el-scrollbar style="height: 100%">
    <div class="header-button">
      <!--留着放查询-->
      <div style="margin-right: 8px;display: flex; align-items:center;">
        <!-- 查询 -->
        <dynamic-search v-if="showSearch"
                        :columnList="columnList"
                        :isReset="isReset"
                        :width="searchWidth"
                        :isHasQuery="isHasQuery"
                        :customSearchText="customSearchText"
                        :fuzzy-fields="fuzzyFields"
                        :fuzzy-field-names="fuzzyFieldNames"
                        @search="searchByQueryJson"
                        @resetSearch="resetSearch"
                        ref="dynamicSearch">
        </dynamic-search>
        <slot name="custom-search"></slot>
      </div>
      <head-button :buttons="buttons"
                   :needI18n="needI18n"
                   :multipleSelection="multipleSelection"
                   @clickButton="handleOption"></head-button>
    </div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'TableHeader',
  props: {
    searchWidth: {
      type: Number,
      default: 600
    },
    searchByQueryJson: {
      type: Function,
      default: () => () => {
      }
    },
    resetSearch: {
      type: Function,
      default: () => () => {
      }
    },
    isReset: {
      type: Boolean,
      default: false
    },
    // 是否存在查询条件
    isHasQuery: {
      type: Boolean,
      default: false
    },
    // 指定模糊查询相关字段
    fuzzyFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 指定模糊查询相关字段名称
    fuzzyFieldNames: {
      type: Array,
      default: () => {
        return []
      }
    },
    columnList: {
      type: Array,
      default: function () {
        return []
      }
    },
    multipleSelection: {
      type: Array,
      default: function () {
        return []
      }
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    buttons: {
      type: Array,
      default: function () {
        return this.$router.currentRoute.meta.buttons || []
      }
    },
    needI18n: {
      type: Boolean,
      default: true
    },
    // 外部传进来的查询文本
    customSearchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    // 总的事件调用方法
    handleOption(eveName, ...parameters) {
      /* 修改 By meijiangshun 解决button在多层组件下，无法获取按钮事件 */
      let parent = this.$parent
      while (parent) {
        if (parent[eveName]) {
          parent[eveName](...parameters)
          return
        }
        parent = parent.$parent
      }
      this.$message({
        showClose: true,
        message: eveName + '方法不存在哦',
        type: 'warning'
      })
      /* 修改结束 */

      /** 修改前代码
       if (this.$parent[eveName] === undefined) {
        this.$message({
          showClose: true,
          message: eveName + '方法不存在哦',
          type: 'warning'
        })
        return
      }
       this.$parent[eveName](...parameters)
       **/
    }
  }
}
</script>

<style scoped>
  .header-button {
    height: 45px;
    padding: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableHeader/header.vue